import styles from "./antheRsTable.module.css";
import { useEffect, useState } from "react";
const RelativePerformanceTable = (props) => {
  const [rlaTable, setRlaTable] = useState([]);
  const [head1, setHead] = useState([]);

  useEffect(() => {
    if (props.data) {
      let score = [];
      let tableData = [];

      props.data.subject_performance.map((item) => {
        score.push(item);
      });
      setRlaTable(score);
    }
  }, []);

  return (
    <div className={styles.tableWrapper}>
      <div style={{ minWidth: "400px" }}>
        <div className={styles.difficut_analysis_section}>
          <p
            style={{
              color: props.exam_type === 'iACST' ? '#009CDE' : '#2B7DCA',
              fontFamily: "Outfit-Medium",
              letterSpacing: "1.2px",
              fontSize: "44px",
            }}
          >
            <b style={{color: props.exam_type === 'iACST' ? '#009CDE' : '#2B7DCA',}}> 
              {" "}
              RELATIVE PERFORMANCE <br /> ANALYSIS - SUBJECT WISE
            </b>
          </p>
        </div>
        <table style={{ minWidth: "400px" }} className={styles.antheRTable}>
          <thead className={styles.antheRThead}>
            <tr className={styles.antheRTr}>
              <th className={`${styles.antheRth} text-start p-4`}>Subjects</th>
              <th className={styles.antheRth}>
                No. of Questions Correctly<br/> answered by you
              </th>
              <th className={styles.antheRth}>
                No. of Questions Wrongly<br/> answered by you
              </th>
              <th className={styles.antheRth}>
                No. of Questions NOT <br/>answered (Blank) by you
              </th>
            </tr>
          </thead>
          <tbody className={styles.antheRTbody}>
            {rlaTable.map((ele, index) => {
              return (
                <tr key={"rtable" + index} className={styles.rtr}>
                  <td className="text-left p-4 dashed-borderBottom text-start font-size-xl">
                    {ele.subject}
                  </td>
                  <td className={styles.antheRTd}>
                    <div className={styles.answerValues}>
                      {ele.correct_answered_questions}
                    </div>
                    <div
                      className={styles.bottomTd}
                      style={{
                        backgroundColor: "#81C9C6",
                      }}
                    >
                      {ele.correct_answered_count + " Questions"}
                    </div>
                  </td>
                  <td className={styles.antheRTd}>
                    <div className={styles.answerValues}>
                      {ele.wrong_answered_questions}
                    </div>
                    <div
                      className={styles.bottomTd}
                      style={{
                        backgroundColor: "#0F4C8C",
                      }}
                    >
                      {ele.wrong_answered_count + " Questions"}
                    </div>
                  </td>
                  <td className={styles.antheRTd}>
                    <div className={styles.answerValues}>
                      {ele.not_answered_questions}
                    </div>
                    <div
                      className={styles.bottomTd}
                      style={{
                        backgroundColor: "#ee837a",
                      }}
                    >
                      {ele.not_answered_count + " Questions"}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RelativePerformanceTable;
